import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../../../environments/environment';
import {TokenService} from './token.service';
import { ApplicationType } from '../enums/enums';

@Injectable()
export class AuthorizationService {

  constructor(private localStorageService: LocalStorageService, private tokenService: TokenService,
              private cookieService: CookieService) {
  }

  readonly REFRESH_TOKEN_TAG: string = 'jwt_refresh_token_' + environment.environmentName;
  readonly TOKEN_TAG: string = 'jwt_' + environment.environmentName;

  public isUserLoggedIn(): boolean {
    return this.doesTokenExist();
  }

  public doesUserHaveMaintenanceAccount(): boolean {
    const applications: ApplicationType[] = this.tokenService.getApplications().map(a => a.Type);
    return applications.some(app => app === ApplicationType.MAINTENANCE);
  }

  public refreshSession() {
    this.setSession(this.getToken(), this.getRefreshToken());
  }

  private setSession(token: string, refreshToken: string) {
    this.tokenService.init(token, refreshToken);
    this.localStorageService.setLoginId(this.tokenService.getLoginId());
    this.localStorageService.setExpire(this.tokenService.getExp());
    this.localStorageService.setCulture(this.tokenService.getCulture());
  }

  public clearSession() {
    this.localStorageService.deleteExpire();
    this.localStorageService.deleteLoginId();
  }

  public getRefreshToken(): string {
    return this.cookieService.get(this.REFRESH_TOKEN_TAG);
  }

  public getToken(): any {
    const token = this.cookieService.get(this.TOKEN_TAG);
    return (token == null || token === '') ? null : token;
  }

  public doesTokenExist(): boolean {
    return this.cookieService.check(this.TOKEN_TAG);
  }
}
